<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table
      ref="zoneTable"
      search
      :data="zones"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-row vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="12">
            <feather-icon icon="PlusCircleIcon" class="cursor-pointer mr-5" svg-classes="h-6 w-6" @click="addNewZone" />
          </vs-col>
        </vs-row>
      </div>
      <template slot="thead">
        <vs-th>{{$t('Action')}}</vs-th>
        <vs-th sort-key="name">{{$t('Drilling.Zones.Name')}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="150px" class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="openDeleteConfirm(tr.zoneId, tr.name)"
              />
            </vs-td>
            <vs-td >
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-prompt
      @cancel="initZonePrompt"
      @accept="acceptZoneName"
      @close="initZonePrompt"
      :title="$t('Drilling.Zones.Edit')"
      :active.sync="activeZonePrompt">
      <div>
        <span>{{ $t('Drilling.Zones.ZonePlaceholder')}}</span>
        <vs-input :placeholder="$t('Drilling.Zones.ZonePlaceholder')" v-model="zoneName" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </div>
</template>
<script>

export default {
  components: {

  },
  props: {
    zones: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      zoneName : "",
      zoneId : 0,
      zoneOldName : "",
      zoneProjectId : 0,
      activeZonePrompt : false
    };
  },

  mounted() {
    
  },
  methods: {
    initZonePrompt() {
      this.activeZonePrompt = false;
      this.zoneId = 0;
      this.zoneName = "";
      this.zoneOldName = "";
      this.zoneProjectId = 0;
    },
    addNewZone() {
      this.activeZonePrompt = true;
      this.zoneId = 0;
      this.zoneName = "";
      this.zoneOldName = "";
      this.zoneProjectId = 0;

    },
    acceptZoneName() {
      const zone = {
        zoneId : this.zoneId,
        name : this.zoneName,
        projectId : this.zoneProjectId
      };

      if (this.zoneOldName === '') {
        this.$emit("onZoneInserted",  zone);
      } else {
        this.$emit("onZoneUpdated",  zone, this.zoneOldName);
      }
     
    },
    openDeleteConfirm(zoneId, zoneName) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Zones.ConfirmDelete'),
        accept: () => this.deleteRecord(zoneId, zoneName)
      });

    },
    deleteRecord (zoneId, zoneName) {
      this.$emit("onDeleteZone", zoneId, zoneName);
    },

    editData(data) {
      this.activeZonePrompt = true;
      this.zoneId = data.zoneId;
      this.zoneProjectId = data.projectId;
      this.zoneName = data.name;
      this.zoneOldName = data.name;
    }
  }
};
</script>
<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
